<template>
  <SearchBar
    :keyword="keyword"
    :search-result="searchResult"
    :placeholder="placeholder"
    @search="search"
    @inputKeyword="$emit('inputKeyword', $event)"
    @pagination="$emit('pagination', $event)"
  >
    <slot />
    <template v-slot:searchArea>
      <slot name="searchArea" />
      <v-checkbox
        :value="checkbox"
        :label="checkboxLabel"
        style="max-width:400px;"
        class="pt-4"
        @change="onChangeCheckbox"
      />
    </template>
  </SearchBar>
</template>

<script>
import SearchBar from './SearchBar'
export default {
  name: 'SearchBarRequest',
  components: { SearchBar },
  props: {
    searchResult: {
      type: Object,
      default: () => {},
    },
    placeholder: {
      type: String,
      default: '検索',
    },
    checkboxLabel: {
      type: String,
      default: '未承認のデータも表示する',
    },
    keyword: {
      type: String,
      default: '',
    },
    checkbox: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tempCheckboxValue: this.checkbox,
      tempKeyword: '',
    }
  },
  methods: {
    search(keyword) {
      this.tempKeyword = keyword
      // 検索ボタン押下で検索してきたときに、このコンポーネント内にも持っておくことで、
      // チェックボックスを変えたときにも同じkeywordでsearchを叩くことができる。
      this.$emit('search', {
        keyword: this.tempKeyword,
        requestStatus: this.tempCheckboxValue ? 'all' : 'approved',
      })
    },
    onChangeCheckbox(value) {
      this.tempCheckboxValue = value
      this.$emit('inputCheckbox', value)
      this.search(this.tempKeyword)
    },
  },
}
</script>
